module.exports = __webpack_public_path__ + "static/media/app_store_full.1d0d3914.svg";